<template>
	<div class="consult-page">
		<iframe
			src="https://widget.figo.cn/chat-page?appId=fc_PQlur8Z8ziSfoNyfJhBR_Bhx"
			style="width:100%;min-height:100%;border:none;"
			allow="microphone"
			loading="lazy">
		</iframe>
	</div>
</template>
<script>
	export default {
		name: "ConsultIndex",
		data() {
			return {};
		},
		mounted() {
			if (this.$el && this.$el.parentElement) {
				this.$el.parentElement.style.minHeight = '0';
			}
		},
		beforeDestroy() {
			if (this.$el && this.$el.parentElement) {
				this.$el.parentElement.style.minHeight = '77vh';
			}
		}
	};
</script>
<style scoped>
	.consult-page {
		width: 100%;
		height: calc(100vh - 160px);
		margin-top: -30px;
	}
</style>
